<template>
  <div class="card">
    <div class="card-body">
      <div class="row">
        <div class="col-lg-4">
          <router-link :to="{ name: 'tableroCompras' }">
            <div class="cantidad">
              123
            </div>
            <div class="text-danger text-center" style="font-size: 15px;">
              Órdenes de compra
            </div>
          </router-link>
        </div>
        <div class="activos col-lg-4">
          <router-link :to="{ name: 'tableroCompras' }">
            <div class="cantidad">
              123
            </div>
            <div class="text-warning text-center" style="font-size: 15px;">
              Órdenes pendientes de compra
            </div>
          </router-link>
        </div>
        <div class="col-lg-4 text-center">
          <router-link :to="{ name: 'tableroCompras' }">
            <div class="cantidad">
              12312
            </div>
            <div style="font-size: 15px;">
              Compras realizadas
            </div>
          </router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  
}
</script>

<style scoped>
.cantidad {
  width: 100%;
  text-align: center;
  font-weight: 200;
  font-size: 23px;
}

.botonSoporte {
  font-size: 23px;
  color: #777;
}
</style>
